import React, { useEffect, useRef, useParams, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Tag } from "primereact/tag";
import { getVcompNotifications } from "../../../containers/dashboard/dashboardSlice";
import { Localize } from "../../../app/lang/langs";
import styles from "../Dashboard.module.css";
import { useNavigate } from "react-router-dom";


export default function VcompManageNotification() {

    const dispatch = useDispatch();
    const mounted = useRef(false);
    const navigate = useNavigate();
    const vcompManageNotification = useSelector(
        (state) => state.dashboard.vcompManageNotification
    );
    const selectedTeamsIds = useSelector((state) => state.teams.selectedTeamsIds)

    const [expandedRows, setExpandedRows] = useState(null);

    useEffect(() => {
        if (!mounted.current) {
            dispatch(getVcompNotifications());
            mounted.current = true;
        }
    }, [mounted]);

    const sessionBody = (row) => (
        <Tag
            value={`S${row.session_number ?? "-"}`}
            severity="secondary"
            rounded
            className={styles.tag}
        />
    );
    const startDateBody = (row) => (
        <div className={styles.cellWithIcon}>
            <i className="pi pi-calendar" />
            <span>{row.start_date_raw || "-"}</span>
        </div>
    );

    const projectNameBody = (row) => (
        <span className={styles.linkStyle} onClick={() => navToVcompProject(row)}>{row.project_name}</span>
    )
    const navToVcompProject = (rowData) => {
        const encodedLabel = encodeURIComponent(rowData.project_name);
        navigate(`/vcomp/${selectedTeamsIds[0]}/1/${encodedLabel}`);
        //setSelectedTeams([rowData.id_team])
    }


    const expandedRowTemplate = (data) => {
        let collabs = data.collabs || [];
        const collabFullName = (row) => `${row.prenom} ${row.nom}`;
        const isActiveMcq = (row) =>
            row.active_mcq === "1" || row.active_mcq === 1 || row.active_mcq === true;

        const mcqStatusBody = (row) => {
            const active = isActiveMcq(row);
            const answered = !!row.answered;
            if (!active) {
                return (
                    <Tag
                        value={Localize("MCQ_DISABLED") || "MCQ disabled"}
                        severity="secondary"
                        icon="pi pi-ban"
                        rounded
                        className={styles.tagSm}
                    />
                );
            }
            return (
                <Tag
                    value={Localize("MCQ_PENDING") || "Pending"}
                    severity="warning"
                    icon="pi pi-clock"
                    rounded
                    className={styles.tagSm}
                />
            );
        }

        return (
            <DataTable
                value={collabs}
                scrollable
                scrollHeight="200px">
                <Column
                    field="prenom"
                    header={Localize("COLLAB_NAME") || "COLLAB_NAME"}
                    body={collabFullName}
                />
                <Column
                    sortable
                    field="answered"
                    header={Localize("ANSWERED") || "ANSWERED"}
                    body={(row) => (row.answered ? Localize("YES") : Localize("NO"))}
                />
                <Column
                    sortable
                    field="active_mcq"
                    header={Localize("MCQ_STATUS") || "MCQ_STATUS"}
                    body={mcqStatusBody}
                />

            </DataTable>
        )
    }

    const allowExpansion = (rowData) => {
        return rowData.collabs.length > 0;
    };

    return (
        <div className={styles.vcompCard}>
            <DataTable
                value={vcompManageNotification}
                scrollable
                scrollHeight="350px"
                size="small"
                stripedRows
                rowHover
                showGridlines
                emptyMessage={Localize("NO_NOTIFICATIONS") || "No notifications"}
                onRowToggle={(e) => setExpandedRows(e.data)}
                expandedRows={expandedRows}
                rowExpansionTemplate={expandedRowTemplate}
                header={Localize("VCOMP_PROJECTS_TO_MANAGE") || "Vcomp Projects to manage"}
                className="p-datatable-sm"
            >
                <Column expander={allowExpansion} style={{ width: '5rem' }} />

                <Column
                    field="project_name"
                    header={Localize("PROJECT_NAME")}
                    style={{ minWidth: "18rem" }}
                    body={projectNameBody}
                />
                <Column
                    field="start_date_raw"
                    header={Localize("SESSION_START_DATE")}
                    body={startDateBody}
                    style={{ minWidth: "12rem" }}
                />
                <Column
                    field="session_number"
                    header={Localize("SESSION_NUMBER") || "SESSION_NUMBER"}
                    body={sessionBody}
                    style={{ width: "8rem" }}
                />
                <Column
                    field="totalCollabs"
                    header={Localize("TOTAL_COLLABS") || "TOTAL_COLLABS"}
                    style={{ width: "8rem" }}
                />
                <Column
                    field="unansweredCollabs"
                    header={Localize("UNASWERED_COLLABS") || "UNANSWERED_COLLABS"}
                    style={{ width: "8rem" }}
                />


            </DataTable>
        </div>
    )




}